/* eslint-disable camelcase */
// context
import documentContext from '../../contexts/translate/en.json'

// components
import AddRecordUniq from '../../components/AddRecordingUniq/translate/en.json'
import header_en from '../../components/Header/translate/en.json'
import printButton from '../../components/PrintButton/translate/en.json'
import sidebar_en from '../../components/Sidebar/translate/en.json'
import webcamStreamComponent from '../../components/Webcam/translate/en.json'
// pages (/pages)
import pageClients_en from '../../pages/Clients/translate/en.json'
import pageProducts from '../../pages/ProductGroups/translate/en.json'
import pageServices from '../../pages/Services/translate/en.json'

// pages/**
import pageAttendanceScreen from '../../pages/Attendance/translate/en.json'
import pageBillsToPay from '../../pages/BillsToPay/translate/en.json'
import pageBillsToReceive from '../../pages/BillsToReceive/translate/en.json'
import pageCardsMedia from '../../pages/CardsMediaClients/translate/en.json'
import pageCheckout from '../../pages/Checkout/translate/en.json'
import pageComparisons from '../../pages/Comparisons/translate/en.json'
import pageCreatingForms from '../../pages/CreatingForms/translate/en.json'
import pageDocumentPrint from '../../pages/DocumentPrint/translate/en.json'
import pageDocumentsServices from '../../pages/DocumentsServices/translate/en.json'
import pageExamRequest from '../../pages/ExamRequest/translate/en.json'
import pageMeansToReceipts from '../../pages/MeansToReceipts/translate/en.json'
import pagePaymentBill from '../../pages/PaymentBill/translate/en.json'
import pageProductsItems from '../../pages/ProductItems/translate/en.json'
import pageProductsItemsResale from '../../pages/ProductItemsResale/translate/en.json'
import pageProductsHistory from '../../pages/ProductsHistory/translate/en.json'
import pageRealizedCashFlow from '../../pages/RealizedCashFlow/translate/en.json'
import pageRecipe from '../../pages/Recipe/translate/en.json'
import pageReportsTransfer from '../../pages/reportsTransfer/translate/en.json'
import pageScheduling from '../../pages/Scheduling/translate/en.json'
import pageClinic from '../../pages/Settings/AboutClinic/translate/en.json'
import pageAttendance from '../../pages/Settings/Attendance/translate/en.json'
import pageCostCenters from '../../pages/Settings/CostCenters/translate/en.json'
import pageConvenio from '../../pages/Settings/Covenants/translate/en.json'
import pageOrigins from '../../pages/Settings/Origins/translate/en.json'
import pagePaymentSources from '../../pages/Settings/PaymentSources/translate/en.json'
import pageRequiredFields from '../../pages/Settings/RequiredFields/translate/en.json'
import pageSuppliers from '../../pages/Settings/Suppliers/translate/en.json'
import pageTags from '../../pages/Settings/Tags/translate/en.json'
import pageUsers from '../../pages/Settings/Users/translate/en.json'
import pageTagsServices from '../../pages/TagsServices/translate/en.json'
import pageTaxControl from '../../pages/TaxControl/translate/en.json'
import pageTaxUnitControl from '../../pages/TaxControlUnit/translate/en.json'
import pageBudgets from '../../pages/Budgets/translate/en.json'
import pageIndications from '../../pages/Indications/translate/en.json'
import pageDailyBox from '../../pages/DailyBox/translate/en.json'
import pageReportsFinancial from '../../pages/ReportsFinancial/translate/en.json'
import pageReportsServicesAndProducts from '../../pages/ReportsServicesAndProducts/translate/en.json'
import pageReportsMarketing from '../../pages/ReportsMarketing/translate/en.json'
import pageTicketsCanceled from '../../pages/TicketsCanceled/translate/en.json'
import pageBlockTimes from '../../pages/BlockTimes/translate/en.json'
import pageEquipments from '../../pages/Settings/Equipments/translate/en.json'
import pageRegisterClinic from '../../pages/RegisterClinic/translate/en.json'
import pageReportsOperation from '../../pages/ReportsOperation/translate/en.json'
import pageNotes from '../../pages/Notes/translate/en.json'
import pagePayments from "../../pages/Payments/translate/en.json"
import pageConnections from "../../pages/Integrations/Connections/translate/en.json"
import pageBirthdayPeople from "../../pages/Integrations/BirthdayPeople/translate/es.json"

export const en = {
  header: header_en,
  sidebar: sidebar_en,
  AddRecordUniq,
  printButton,
  pageClients: pageClients_en,
  pageClinic,
  pageUsers,
  pageConvenio,
  pageAttendance,
  pageTags,
  pageOrigins,
  pageRequiredFields,
  pageSuppliers,
  pageProducts,
  pageServices,
  pageCostCenters,
  pagePaymentSources,
  pageBillsToPay,
  pagePaymentBill,
  pageScheduling,
  pageTagsServices,
  pageDocumentsServices,
  pageAttendanceScreen,
  pageRecipe,
  pageExamRequest,
  pageCardsMedia,
  documentContext,
  webcamStreamComponent,
  pageComparisons,
  pageMeansToReceipts,
  pageCreatingForms,
  pageBillsToReceive,
  pageCheckout,
  pageProductsItems,
  pageProductsHistory,
  pageRealizedCashFlow,
  pageTaxControl,
  pageTaxUnitControl,
  pageDocumentPrint,
  pageReportsTransfer,
  pageProductsItemsResale,
  pageBudgets,
  pageIndications,
  pageDailyBox,
  pageReportsFinancial,
  pageReportsServicesAndProducts,
  pageTicketsCanceled,
  pageReportsMarketing,
  pageBlockTimes,
  pageEquipments,
  pageRegisterClinic,
  pageReportsOperation,
  pageNotes,
  pagePayments,
  pageConnections,
  pageBirthdayPeople,
  global: {
    btnUpdate: 'Atualizar',
    btnNovo: 'Novo',
    paymentHeader: "Finalize seu pagamento",
    paymentDetails: "Revise os detalhes e confirme para prosseguir.",
    payment: "Pagar Agora",
    dropzoneLabel: 'Clique ou arraste arquivos aqui',
    dropzoneLabelError: 'Arquivo não suportado!',
    dropzoneLabelSuccess: 'Arquivo suportado.',
    dropzoneLabelSize: 'Atenção! arquivos até',
    modalData: 'Gostaria de baixar o documento?',
    noOptionsMessage: 'Sem opções para selecionar',
    modalDataDescription:
      'Seu documento aparecera na lista de downloads quando concluído!',
    remove: 'Excluir',
    documentComponent: {
      i1: 'Tipo de documento',
      i1Option: {
        i1: 'CPF',
        i2: 'CNPJ',
        i3: 'Outros'
      },
      i2: 'Documento'
    }
  }
}
